import { FC } from 'react';
import { Board } from 'types';
import BoardVideos from '../BoardVideos';

type BoardPartnerVideosProps = {
  board: Board;
};

const BoardPartnerVideos: FC<BoardPartnerVideosProps> = ({ board }) => (
  <div className="nk-block">
    <div className="row">
      <div className="col-xl-12">
        <div className="card card-bordered">
          <div className="card-inner pt-0">
            <BoardVideos board={board} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BoardPartnerVideos;

